import {
  OPEN_DROPDOWN,
  CHECK_OPTION,
  SHOW_ALL_CLICK,
  CLOSE_DROPDOWN,
  CHECK_PILL_CAPTURE,
  CLEAR_FILTERS,
  SHOW_ALL_CAPTURES,
  UNCHECK_OPTION,
} from "@constants/filter-constants";

export const initialState = {
  roomType: [],
  furnishingType: [],
  activePill: null,
  showCaptures: false,
};

export const reducer = (state, action) => {
  switch (action.type) {
    case CHECK_OPTION:
      return {
        ...state,
        [action.payload.filterProp]: [
          ...state[action.payload.filterProp],
          action.payload.key,
        ],
      };
    case SHOW_ALL_CLICK:
      return {
        ...state,
        [action.payload.filterProp]: [
          ...state[action.payload.filterProp],
          action.payload.key,
        ],
      };
    case UNCHECK_OPTION:
      return {
        ...state,
        [action.payload.filterProp]: state[action.payload.filterProp].filter(
          (key) => key !== action.payload.key
        ),
      };
    case CHECK_PILL_CAPTURE:
      return {
        ...state,
        showCaptures: !state.showCaptures,
      };
    case SHOW_ALL_CAPTURES:
      return {
        ...state,
        showCaptures: true,
      };
    case CLEAR_FILTERS:
      return initialState;
    case OPEN_DROPDOWN:
      return {
        ...state,
        activePill: action.payload,
      };
    case CLOSE_DROPDOWN:
      return {
        ...state,
        activePill: null,
      };
    default:
      throw new Error(`Unhandled type ${action.type}`);
  }
};
